export enum BrandSpecificInformationCategory {
  FINANCE = 'FINANCE',
  CONTRACT = 'CONTRACT',
  CORPORATE_IDENTITY_EXTERIOR = 'CORPORATE_IDENTITY_EXTERNAL',
  CORPORATE_IDENTITY_INTERIOR = 'CORPORATE_IDENTITY_INTERNAL'
}
